import { useEffect, useState } from 'react';
export const useMountTransition = (active, transitionDuration) => {
    const [visible, setVisible] = useState(false);
    const [render, setRender] = useState(false);
    useEffect(() => {
        let showTimeout;
        let hideTimeout;
        if (active) {
            setRender(true);
            showTimeout = setTimeout(() => setVisible(true), 10);
        }
        else {
            setVisible(false);
            hideTimeout = setTimeout(() => setRender(false), transitionDuration);
        }
        return () => {
            clearTimeout(showTimeout);
            clearTimeout(hideTimeout);
            setRender(false);
            setVisible(false);
        };
    }, [active, transitionDuration]);
    return [render, visible];
};
export default useMountTransition;
